import { useEffect, useState } from 'react';
import axiosClient from '../libs/axiosClient';
import { setToken } from './auth';
import { handleRedirectUrlCheck } from '../common/redirectUrlCheck';

const FACEBOOK_APP_ID = '1226778651867727';
const FACEBOOK_REDIRECT_URI = `${window.location.origin}/auth/facebook/callback`;
export const FACEBOOK_AUTH_URL = `https://www.facebook.com/v21.0/dialog/oauth?client_id=${FACEBOOK_APP_ID}&redirect_uri=${FACEBOOK_REDIRECT_URI}&path=me?fields=id,name,email&scope=email,public_profile`;
// export const FACEBOOK_AUTH_URL = `https://www.facebook.com/v21.0/dialog/oauth?client_id=${FACEBOOK_APP_ID}&redirect_uri=${FACEBOOK_REDIRECT_URI}&scope=email,public_profile`;

function Facebook() {
  useEffect(() => {
    const params = new URL(document.URL).searchParams;
    const code = params.get('code');

    axiosClient
      .post(
        '/func/user/login/facebook',
        {
          code: code,
          redirect_uri: FACEBOOK_REDIRECT_URI,
        },
        {
          headers: {
            'Access-Control-Allow-Origin': 'https://api.us.dietdr.co.kr',
          },
          withCredentials: true,
        },
      )
      .then((res) => {
        setToken(res.data);
        let rurl = localStorage.getItem('rurl');
        if (handleRedirectUrlCheck(rurl || '/')) {
          window.location.href = rurl || '/';
        } else window.location.href = '/';
      })
      .catch((err) => {
        alert(err.response.data.detail);
        window.location.href = '/login';
      });
  }, []);
  return <div></div>;
}

export default Facebook;
